import React from 'react';
import styled from 'styled-components';
import { Section, SectionContent } from '../../components/Section';
import { Heading } from '../../components/typography/Heading';
import { SubHeading } from '../../components/typography/SubHeading';
import { IconWrapper } from '../../components/IconWrapper';
import { LuBriefcase, LuGraduationCap } from 'react-icons/lu';
import { PiChartLineUp } from 'react-icons/pi';
import { ImageContainer, SplitContainer } from '../../components/layout/SplitLayout';
import FounderImage from '../../assets/Founder.jpg';

const TextContent = styled.div`
  // margin-bottom: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 1.125rem;
  line-height: 1.8;
  margin-top: ${({ theme }) => theme.spacing.md};
  max-width: 800px;
`;

const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const FeatureText = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const ExperienceDescription = styled(Description)`
  margin-top: 2rem;
`;

const StyledImageContainer = styled(ImageContainer)`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 60%;
    height: 90%;
    position: unset;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      height: 100%;
    }
  }
`;

export const OurExperience: React.FC = () => {
  return (
    <Section backgroundColor="white">
      <SectionContent>
        <SplitContainer>
          <TextContent>
            <SubHeading>OUR EXPERIENCE</SubHeading>
            <Heading>
              <em>Seasoned professionals</em> with deep market expertise and proven track record
            </Heading>
            <Description>
              An AMFI registered Mutual Fund distributor with aim to offer customized portfolio management services to
              help build long term, sustainable wealth.
            </Description>

            <FeaturesContainer>
              <FeatureItem>
                <IconWrapper size="small">
                  <LuBriefcase />
                </IconWrapper>
                <FeatureText>Customized Portfolio Management</FeatureText>
              </FeatureItem>

              <FeatureItem>
                <IconWrapper size="small">
                  <PiChartLineUp />
                </IconWrapper>
                <FeatureText>Long-term Wealth Building</FeatureText>
              </FeatureItem>

              <FeatureItem>
                <IconWrapper size="small">
                  <LuGraduationCap />
                </IconWrapper>
                <FeatureText>Professional Expertise</FeatureText>
              </FeatureItem>
            </FeaturesContainer>
            <ExperienceDescription>
              Your Distributor, Amit Mody is a seasoned investment professional with more than 10 years of experience
              across investment banking and consulting across sectors. He has keen interest in the capital markets with
              sector expertise across Pharma, Banking, IT, Auto amongst others and has been actively involved in asset
              management for more than 10 years
            </ExperienceDescription>
          </TextContent>
          <StyledImageContainer>
            <img src={FounderImage} alt="Founder" />
          </StyledImageContainer>
        </SplitContainer>
      </SectionContent>
    </Section>
  );
};
